<template>
  <div>
    <vs-card>
      <b-row align-h="start">
        <b-col :cols="isMobile() ? 12 : 3" md="auto" style="padding-right: 2px">
          <b-button
            style="border-color: white"
            v-on:click="filterShelf()"
            class="vs-con-loading__container bg-primary"
            id="loading-shelf-list"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("ListShelf") }}
          </b-button>
          <b-button
            style="border-color: white"
            v-on:click="filterCorridor()"
            class="vs-con-loading__container bg-primary"
            id="loading-corridor-list"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("ListCorridor") }}
          </b-button>
        </b-col>

        <b-col>
          <b-row align-h="end">
            <b-col :cols="isMobile() ? 12 : 3" md="auto">
              <b-dropdown
                size="sm"
                id="dropdown-1"
                :text="$t('TotalActions')"
                class="bg-primary"
                style="border-color: white"
              >
                <b-dropdown-item-button
                  @click="
                    wholeStockActions = true;
                    printBarcodeControl(true);
                  "
                >
                  <span class="flex items-center">
                    <feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>{{ $t("PrintBarcode") }}</span>
                  </span>
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  @click="
                    wholeStockActions = true;
                    addStockToShelf();
                  "
                >
                  <span class="flex items-center">
                    <Icon
                      icon="clarity:bundle-line"
                      width="16"
                      class="mr-2"
                      height="16"
                    />
                    <span>{{ $t("AddStockToShelf") }}</span>
                  </span>
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  @click="
                    wholeStockActions = true;
                    addStockToShelfWithSerial();
                  "
                >
                  <span class="flex items-center">
                    <Icon
                      icon="iconoir:pin"
                      width="16"
                      class="mr-2"
                      height="16"
                    />
                    <span>{{ $t("AddStockToShelfWithSerial") }}</span>
                  </span>
                </b-dropdown-item-button>
              </b-dropdown>
            </b-col>
            <b-col :cols="isMobile() ? 12 : 3" md="auto">
              <b-button
                class="bg-warning"
                style="border-color: white"
                v-on:click="addCorridor()"
              >
                <Icon
                  :icon="'mingcute:add-line'"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("AddNew") }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <div slot="header">
        <h3>
          {{ $t(tableTitle) }}
        </h3>
      </div>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
    <ShelfAddNew
      :isSidebarActive="isSidebarActiveShelf"
      :data="corridorData"
      :shelfDetailData="shelfDetailData"
      @closeSidebar="toggleShelfSidebar"
    />
    <CorridorAddNew
      :isSidebarActive="isSidebarActiveCorridor"
      :data="corridorData"
      @closeSidebar="toggleCorridorSidebar"
    />
    <AddStockToShelfPopup
      :isSidebarActive="isSidebarActiveShelfProduct"
      :data="corridorData"
      @closeSidebar="toggleShelfProductSidebar"
    />
    <ProductListToShelf
      :isSidebarActive="isSidebarActiveShelfProductList"
      :ShelfCode="shelfCode"
      @closeSidebar="toggleShelfProductListSidebar"
    />
    <DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="shelfDelete"
      :active.sync="isSidebarActiveProcess"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
    <vs-popup
      class="holamundo"
      :title="$t('PrintBarcode')"
      :active.sync="isSidebarActiveBarcodePrintTemp"
      @close="printBarcode"
      @cancel="printBarcode"
      fullscreen
    >
      <BarcodePrintingTamplate
        :isSidebarActive="isSidebarActiveBarcodePrintTemp"
        :name="'depotBarcodeTemplate'"
        :data="filteredData"
        @closeSidebar="printBarcode"
      />
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
import moment from "moment";
import CorridorAddNew from "./CorridorAddNew.vue";
import threeInfoButtonsDynamic from "../CellRenderers/threeInfoButtonsDynamic.vue";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import ShelfAddNew from "./ShelfAddNew.vue";
import AddStockToShelfPopup from "./AddStockToShelfPopup.vue";
import ProductListToShelf from "./ProductListToShelf";
import BarcodePrintingTamplate from "../components/global-components/BarcodePrintingTamplate.vue";
import { isMobile } from "mobile-device-detect";
export default {
  data() {
    return {
      isMobile: function () {
        return isMobile;
      },
      isSidebarActiveBarcodePrintTemp: false,
      wholeStockActions: false,
      tableTitle: "",
      isSidebarActiveProcess: false,
      shelfCode: "",
      isSidebarActiveShelfProductList: false,
      isSidebarActiveShelfProduct: false,
      shelfProductData: [],
      shelfDetailData: [],
      deleteWarningPromptValid: false,
      deleteData: [{}],
      isSidebarActiveShelf: false,
      shelfData: [],
      isSidebarActiveCorridor: false,
      locale: "de",
      weekday: 1,
      corridorData: "",
      infoData: [],
      endDate: "",
      startDate: "",
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
      shelfDeleteData: "",
      filteredData: [],
    };
  },
  components: {
    BarcodePrintingTamplate,
    ProductListToShelf,
    AddStockToShelfPopup,
    ShelfAddNew,
    threeInfoButtonsDynamic,
    CorridorAddNew,
    detailBtnCellRenderer,
    AgGridVue,
    Icon,
    DeleteWarning,
  },
  methods: {
    addShelfTrans() {
      this.$router
        .push({
          name: "shelf-transfer",
        })
        .catch(() => {});
    },
    printBarcodeControl() {
      this.printAcceptedValues = [];
      var selectedRows = this.gridApi.getSelectedRows();
      this.filteredData = selectedRows;

      if (this.filteredData.length > 0) this.printBarcode(true);
      else {
        const vs = this.$vs;

        vs.notify({
          text: this.$t("Validate"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      }
    },
    printBarcode(val = false) {
      this.isSidebarActiveBarcodePrintTemp = val;
    },
    addProduct() {
      this.toggleShelfProductListSidebar(true);
    },
    toggleShelfProductListSidebar(val = false) {
      this.isSidebarActiveShelfProductList = val;
    },

    addStockToShelf() {
      //  this.toggleShelfProductSidebar(true);
      //    window.open(this.$router.resolve({ name: "add-stock-shelf" }).href, "_blank");
      this.$router
        .push({
          name: "add-stock-shelf",
        })
        .catch(() => {});
    },
    addStockToShelfWithSerial() {
      this.$router
        .push({
          name: "add-stock-shelf-serial",
        })
        .catch(() => {});
    },
    toggleShelfProductSidebar(val = false) {
      if (val == false) {
        this.shelfProductData = "";
      }
      this.isSidebarActiveShelfProduct = val;
    },
    toggleShelfSidebar(val = false) {
      if (val == false) {
        this.shelfData = "";
        this.corridorData = "";
        this.shelfDetailData = "";
      }
      this.isSidebarActiveShelf = val;
    },
    toggleCorridorSidebar(val = false) {
      if (val == false) {
        this.corridorData = "";
        this.shelfData = "";
        this.shelfDetailData = "";
      }
      this.isSidebarActiveCorridor = val;
    },
    addCorridor() {
      this.toggleCorridorSidebar(true);
    },
    parseDate(params) {
      return moment(String(params)).format("YYYY-MM-DD HH:mm");
    },
    onFirstDataRendered(params) {
      //  params.api.sizeColumnsToFit();
    },
    getShelfColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          headerCheckboxSelection: true,
          checkboxSelection: true,
          showDisabledCheckboxes: true,
          width: 170,
          pinned: "left",
          cellRendererFramework: "threeInfoButtonsDynamic",
          cellRendererParams: {
            detailMethodsOne: "shelfDetail",
            iconDetailOne: "material-symbols:edit",
            iconColorOne: "#065a82",
            tooltipOne: "Edit",
            detailMethodsTwo: "shelfDelete",
            iconDetailTwo: "ic:baseline-remove-circle",
            iconColorTwo: "#fe6d73",
            tooltipTwo: "Delete",
            detailMethodsTree: "addProduct",
            iconDetailTree: "clarity:rack-server-solid-badged",
            iconColorTree: "#17c3b2",
            tooltipTree: "ListProduct",
          },
        });
        columnList.forEach((val, index) => {
          if (
            (val == "CompanyName" || val == "Barcode" || val == "Description") &&
            !this.isMobile()
          ) {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columnsProcess.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (
            val.toString().includes("Id") == false &&
            val.toString().includes("TrasnType") == false
          ) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },
    getCorridorColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 130,
          pinned: "left",
          cellRendererFramework: "threeInfoButtonsDynamic",
          cellRendererParams: {
            detailMethodsOne: "corridorDetail",
            iconDetailOne: "material-symbols:edit",
            iconColorOne: "#065a82",
            tooltipOne: "Edit",
            detailMethodsTwo: "corridorDelete",
            iconDetailTwo: "ic:baseline-remove-circle",
            iconColorTwo: "#fe6d73",
            tooltipTwo: "Delete",
            detailMethodsTree: "addShelf",
            iconDetailTree: "lucide-lab:floor-plan",
            iconColorTree: "#17c3b2",
            tooltipTree: "AddShelf",
          },
        });
        columnList.forEach((val, index) => {
          if (
            (val == "CompanyName" || val == "Barcode" || val == "Description") &&
            !this.isMobile()
          ) {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columnsProcess.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (
            val.toString().includes("Id") == false &&
            val.toString().includes("TrasnType") == false
          ) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },
    filterShelf() {
      const vs = this.$vs;
      this.tableTitle = "ShelfList";
      let type = "material";
      setTimeout(() => {
        vs.loading({
          container: `#loading-shelf-list`,
          type,
          scale: 0.5,
        });
      }, 500);

      this.$store
        .dispatch("storehouse/listShelf")
        .then((response) => {
          setTimeout(() => {
            vs.loading.close("#loading-shelf-list > .con-vs-loading");
          }, 1000);
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-shelf-list > .con-vs-loading");
          }, 1000);
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    filterCorridor() {
      const vs = this.$vs;
      this.tableTitle = "CorridorList";
      let type = "material";
      vs.loading({
        container: `#loading-corridor-list`,
        type,
        scale: 0.5,
      });
      this.$store
        .dispatch("storehouse/listCorridor")
        .then((response) => {
          setTimeout(() => {
            vs.loading.close("#loading-corridor-list > .con-vs-loading");
          }, 1000);
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-corridor-list > .con-vs-loading");
          }, 1000);
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    corridorDetail() {
      this.toggleCorridorSidebar(true);
    },
    corridorDelete() {
      this.deleteWarningPromptValid = true;
    },
    closeDeleteWarning() {
      this.deleteWarningPromptValid = false;
    },
    deleteSubmit(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("storehouse/deleteCorridor", data.CorridorId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.filterCorridor();
              this.deleteWarningPromptValid = false;
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    addShelf() {
      this.isSidebarActiveShelf = true;
    },
    shelfDetail() {
      this.toggleShelfSidebar(true);
    },
    shelfDelete() {
      const vs = this.$vs;
      this.$store
        .dispatch("storehouse/deleteShelf", this.deleteData.ShelfId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.filterShelf();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    shelfAll: {
      get() {
        return this.$store.state.storehouse.ShelfAll;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    corridor: {
      get() {
        return this.$store.state.storehouse.Corridor;
      },
      set(val) {
        if (!val) {
        }
      },
    },

    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    this.$root.$on("shelfDelete", (data) => {
      this.deleteData = data;
      this.isSidebarActiveProcess = true;
    });

    this.$root.$on("shelfDetail", (data) => {
      this.shelfDetailData = data;
      this.shelfDetail(data);
    });
    this.$root.$on("corridorDetail", (data) => {
      this.corridorData = data;
      this.corridorDetail(data);
    });
    this.$root.$on("corridorDelete", (data) => {
      this.deleteData = data;
      this.corridorDelete(data);
    });
    this.$root.$on("addShelf", (data) => {
      this.corridorData = data;
      this.addShelf(data);
    });
    this.$root.$on("addProduct", (data) => {
      this.shelfData = data;
      this.shelfCode = data.ShelfCode;

      this.addProduct(data);
    });
    this.$root.$on("filterCorridor", () => {
      this.filterCorridor();
    });
    this.$root.$on("closeDeleteWarning", () => {
      this.closeDeleteWarning();
    });
    this.$root.$on("deleteSubmit", (data) => {
      this.deleteSubmit(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("shelfDelete");
    this.$root.$off("corridorDetail");
    this.$root.$off("corridorDelete");
    this.$root.$off("addShelf");
    this.$root.$off("filterCorridor");
    this.$root.$off("closeDeleteWarning");
    this.$root.$off("deleteSubmit");
    this.$root.$off("deleteDataBtn");
    this.$root.$off("addProduct");
  },
  watch: {
    shelfAll(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getShelfColumnList();
      }
      return val;
    },
    corridor(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getCorridorColumnList();
      }
      return val;
    },
  },
  created() {
    this.filterShelf();
  },
};
</script>
<style lang="scss">
[dir] .btn-group button {
  padding: 5px !important;
}
</style>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 230px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
